import React, { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { Label, Input } from "reactstrap";
import { useLoader } from "../../_helper/LoaderContext";
import { useLab } from "../../_helper/PharmacyProvider";
import { paymentIn, paymentOut } from "./service/payment-service";
import { toast } from "react-toastify";
import CurrencyAmountInput from "../CurrencyAmountInput";
import DatePicker from "../Common/Component/DatePicker";

export default function AddPay({ show, onHide, getList }) {
    const [date, setDate] = useState(() => new Date().toISOString().split("T")[0]);
    const [amount, setAmount] = useState("");
    const [type, setType] = useState(""); // payin / payout
    const [note, setNote] = useState("");
    const { setLoading } = useLoader();
    const { currentLab } = useLab()
    const [selectedPaymentCurrency, setSelectedPaymentCurrency] = useState(currentLab.baseCurrency);

    // Validation errors
    const [errors, setErrors] = useState({});

    const handleSubmit = async () => {
        const newErrors = {};
        if (!amount || Number(amount) <= 0) {
            newErrors.amount = "Amount is required and must be greater than 0.";
        }

        if (!type) {
            newErrors.type = "Please select Pay-In or Pay-Out.";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;   // ← EARLY RETURN

        setLoading(true);
        try {
            const form_data = new FormData();
            form_data.append("amount", amount);
            // form_data.append("currencyType", currentLab?.baseCurrency);
            form_data.append("reason", note);
            form_data.append("type", type);
            form_data.append("currencyType", selectedPaymentCurrency);
            form_data.forEach((key, value) => console.log(value + " :" + key))
            let res;

            if (type === "payin") {
                res = await paymentIn(form_data);
            } else {
                res = await paymentOut(form_data);
            }

            if (res.data.success) {
                toast.success(res.data.message);
                onHide();
                setAmount("");
                setType("");
                setNote("");
                getList();
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal show={show} onHide={onHide} scrollable centered>
                <Modal.Header closeButton>
                    <Modal.Title>Paid-In Paid-Out</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>

                        {/* Date */}
                        <Form.Group className="mb-3">
                            <Form.Label>Date</Form.Label>
                            <DatePicker
                                name="date"
                                value={date}
                                onChange={(event) => setDate(event.target.value || "")}
                            />
                        </Form.Group>

                        {/* Amount */}
                        <Form.Group className="mb-3">
                            <Form.Label>Amount
                                <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="d-flex">
                                <input
                                    type="number"
                                    placeholder="Enter Amount"
                                    className="form-control rounded-start"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    isInvalid={!!errors.amount}
                                    style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}
                                />
                                <select
                                    onChange={(e) => {
                                        setSelectedPaymentCurrency(e.target.value)
                                    }}
                                    className={`form-select rounded-end`}
                                    style={{ width: '140px', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }}
                                >
                                    {currentLab.allowedCurrencies.map((cur) => (
                                        <option key={cur} value={cur}>
                                            {cur}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <Form.Control.Feedback type="invalid">
                                {errors.amount}
                            </Form.Control.Feedback>
                        </Form.Group>

                        {/* Pay-in / Pay-out */}
                        <Form.Group className="mb-3">
                            <Form.Label>Type
                                <span className="text-danger">*</span>
                            </Form.Label>
                            <div className="d-flex gap-3 mt-1">

                                <div className="radio radio-primary">
                                    <Input
                                        id="customer-payin"
                                        type="radio"
                                        name="paytype"
                                        value="payin"
                                        checked={type === "payin"}
                                        onChange={(e) => setType(e.target.value)}
                                    />
                                    <Label for="customer-payin" className="mb-0 pe-2">
                                        Paid In
                                    </Label>
                                </div>

                                <div className="radio radio-primary">
                                    <Input
                                        id="customer-payout"
                                        type="radio"
                                        name="paytype"
                                        value="payout"
                                        checked={type === "payout"}
                                        onChange={(e) => setType(e.target.value)}
                                    />
                                    <Label for="customer-payout" className="mb-0 pe-2">
                                        Paid Out
                                    </Label>
                                </div>
                            </div>
                            {errors.type && (
                                <div className="text-danger mt-1">{errors.type}</div>
                            )}
                        </Form.Group>

                        {/* Note */}
                        <Form.Group>
                            <Form.Label>Note</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Write Note (optional)"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer className="tw-justify-end">
                    <Button variant="primary" onClick={handleSubmit}>
                        Submit
                    </Button>
                    <Button variant="secondary" onClick={onHide}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
